export default "__VITE_ASSET__eBWik92H__"